import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthProvider from './Context/AuthContext';
import { CartProvider } from './Context/CartContext';
import Cart from './components/Cart/Cart';
import Home from './pages/Home/Home';
import Collections from './pages/Collections/Collections';
import ProductDetails from './pages/ProductDetails/ProductDetails';
import CategoryPage from './pages/CategoryPage/CategoryPage';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import AboutUs from './pages/AboutUs/AboutUs';
import ContactUs from './pages/ContactUs/ContactUs';
import SearchResults from './pages/SearchResults/SearchResults';
import ThankYou from './pages/ThankYou/ThankYou';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Cart />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/product/:productId" element={<ProductDetails />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/thankyou" element={<ThankYou />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
